import { tick } from "@simplybusiness/icons";
import { Icon } from "../Icon";
import { VisuallyHidden } from "../VisuallyHidden";

const Success = () => (
  <>
    <div className="mobius-button__icon-wrapper">
      <Icon icon={tick} size="md" />
    </div>
    <VisuallyHidden className="mobius-button__success-text">
      Success
    </VisuallyHidden>
  </>
);

export { Success };
